import moment from 'moment';
import "moment/locale/th";

// ปรับให้ใช้ locale ภาษาไทย
moment.locale('th');

// Get current date-time in 24-hour format
export const getCurrentDateTime = (format = 'D MMMM YYYY เวลา HH:mm:ss') => {
  return moment().add(543, 'year').format(format);
};

// Format full date-time
export function formatDateTime(value) {
  // return moment(String(value)).add(543, 'year').format('D MMM YY HH:mm:ss');
  return moment.utc(value) // ⬅️ ใช้ UTC
    .locale('th')         // ภาษาไทย
    .format('DD MMM YYYY HH:mm') // แสดงเวลาแบบไม่แปลง
    .replace(`${moment.utc(value).year()}`, `${moment.utc(value).year() + 543}`); // แปลงปีเป็น พ.ศ.
}

// Format only date
export function formatDate(value) {
  return moment(String(value)).add(543, 'year').format('D MMM YY');
}

// Format only time (24-hour with "น.")
export function formatTime(value) {
  return moment(String(value), 'HH:mm:ss').format('HH:mm น.');
}
